import { render, staticRenderFns } from "./DashboardJourney.vue?vue&type=template&id=67348393&scoped=true&"
import script from "./DashboardJourney.vue?vue&type=script&lang=js&"
export * from "./DashboardJourney.vue?vue&type=script&lang=js&"
import style0 from "./DashboardJourney.vue?vue&type=style&index=0&id=67348393&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67348393",
  null
  
)

export default component.exports